import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import FullSizeSection from '../../components/layout/FullSizeSection'
import FullSizePage from '../../components/layout/FullSizePage'
import FullSizeGallery from '../../components/layout/FullSizeGallery'
import styled from '../../utils/styled'
import Page from '../../components/layout/Page'
import Container from '../../components/layout/Container'
import DataTable from '../../components/layout/DataTable'
import Loadingbar from '../../components/layout/Loaderbar'
import StackGrid from "react-stack-grid";
// import { animateScroll as scroll } from "react-scroll";
import * as Scroll from 'react-scroll';
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

// import { ScrollTo } from "react-scroll-to";


import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Author } from '../../store/authors/types'
// import { fetchRequest, bulkUpdate } from '../../store/authors/actions'
import { fetchRequest, fetchByName bulkUpdate } from '../../store/pages/actions'
import { Dispatch } from 'redux'
import Moment from 'react-moment';
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  // data: Author[]
  data: Page[]
  selected: Page
  errors?: string
}
interface InterfaceProps {
  users?: any
}
interface PassedProps {
  background: String
  colSpan: number
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  bulkUpdate: typeof bulkUpdate
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & InterfaceProps & PassedProps

class AuthorsIndexPage extends React.Component<AllProps> {
  constructor(props: any) {
    super(props)

    this.state = {
      loading: false,
      authors: []
    }
  }
  public componentDidMount() {
    const { data } = this.props
    scrollSpy.update();

    this.props.fetchByName("about")
    // this.props.fetchRequest()
  }


  public createMarkup(str: string) {
    return {
      __html: str
    }
  }
  private handleEvent(event:any) {
    const  route = $(event.currentTarget).attr("to")
    this.props.history.push(route);
  }
  private handleScroll(event:any) {
    // console.log("scrolling", scrollTo);
    // let y = $(event.currentTarget).offset().top-($(event.currentTarget).height()/2);
    // scroll.scrollTo(y, {smooth: true});
  }
  public render() {

    const { selected, loading, match } = this.props
    // console.log(selected)
    return (
      <Page>
        <Container>
          <Wrapper>
            {loading && <Loadingbar />}

            {selected!=undefined && (
              <div>
                <FullSizeSection
                  title={selected.name}
                  // subtitle={selected.hasOwnProperty('category') ? selected.category.name : ""}
                  backgroundImage={
                    selected.hasOwnProperty('cover') ? selected.cover.url : undefined
                  }
                  className="about theme-dark"
                >
                  <div dangerouslySetInnerHTML={this.createMarkup(selected.description)} />
                </FullSizeSection>
  {selected.pages!=null && selected.pages.length>1 && (selected.pages.map((page, index) => (
    <FullSizePage
      key={index}
      title={page.title}
      subtitle={page.subtitle}
      media={page.hasOwnProperty('media') ? page.media : undefined}
      theme={page.theme}
      className={page.hasOwnProperty('media') ? "about-image" : "about"}
    >

      <div dangerouslySetInnerHTML={this.createMarkup(page.body)} />
    </FullSizePage>
  ))}
                {selected.hasOwnProperty('galleryid') && selected.galleryid>0 && (
                  <FullSizeGallery galleryid={selected.galleryid} />
                )}
              </div>
            )}

          </Wrapper>
        </Container>
      </Page>
    )
  }
}
const html = function(body: string) {
  let regex = /userdata/gi
  body = body.replace(regex, 'http://localhost/userdata')
  console.log(body)
  let result = [body]
  return result
}
// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ pages }: ApplicationState) => ({
  loading: pages.loading,
  errors: pages.errors,
  data: pages.data,
  selected: pages.selected
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: () => dispatch(fetchRequest()),
  fetchByName: (name:string) => dispatch(fetchByName(name)),
  bulkUpdate: () => dispatch(bulkUpdate())
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorsIndexPage)


const Wrapper = styled('div')`
  position: relative;
`
